import React from 'react';
import { BookOpen, Users, CheckCircle, Building2 } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

interface StatsProps {
  stats: {
    totalCourses: number;
    publishedCourses: number;
    draftCourses: number;
    totalUsers: number;
    activeUsers: number;
    completedCourses: number;
    totalOrganizations: number;
  };
}

const DashboardStats: React.FC<StatsProps> = ({ stats }) => {
  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4 mb-6">
      <Card className="shadow-sm">
        <CardContent className="flex flex-col items-center justify-center p-4">
          <BookOpen className="h-6 w-6 text-primary mb-1" />
          <h3 className="text-xl font-bold">{stats.totalCourses}</h3>
          <p className="text-muted-foreground text-sm">Total Courses</p>
          <div className="flex justify-between w-full mt-1 text-xs">
            <span className="text-green-600">{stats.publishedCourses} Published</span>
            <span className="text-amber-600">{stats.draftCourses} Draft</span>
          </div>
        </CardContent>
      </Card>
      
      <Card className="shadow-sm">
        <CardContent className="flex flex-col items-center justify-center p-4">
          <CheckCircle className="h-6 w-6 text-primary mb-1" />
          <h3 className="text-xl font-bold">{stats.completedCourses}</h3>
          <p className="text-muted-foreground text-sm">Completed Courses</p>
        </CardContent>
      </Card>
      
      <Card className="shadow-sm">
        <CardContent className="flex flex-col items-center justify-center p-4">
          <Building2 className="h-6 w-6 text-primary mb-1" />
          <h3 className="text-xl font-bold">{stats.totalOrganizations}</h3>
          <p className="text-muted-foreground text-sm">Total Organizations</p>
        </CardContent>
      </Card>
      
      <Card className="shadow-sm">
        <CardContent className="flex flex-col items-center justify-center p-4">
          <Users className="h-6 w-6 text-primary mb-1" />
          <h3 className="text-xl font-bold">{stats.totalUsers}</h3>
          <p className="text-muted-foreground text-sm">Total Users</p>
        </CardContent>
      </Card>
    </div>
  );
};

export default DashboardStats;
